import { useEffect, useState } from "react";
import { adminGet } from "@/lib/adminApi";
import { frDateTime } from "@/components/admin/ClientFiche";

export default function Journal() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    adminGet("/journal").then((d) => setEntries(d.journal)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-journal-module">
      <h2 className="rav-admin-h2">Journal</h2>
      <p className="rav-page-sub rav-admin-note">
        Comment les personnes se sentent après leur Instant — le ressenti qu'elles partagent en fin de séance.
      </p>
      {entries.length === 0 && <p className="rav-page-sub">Aucun ressenti partagé pour le moment.</p>}
      <div className="rav-admin-list">
        {entries.map((e, i) => (
          <div key={i} className="rav-admin-row" data-testid={`journal-row-${i}`}>
            <span className="rav-admin-row-label">
              {e.user_name} — {e.feeling_after}
            </span>
            <span className="rav-admin-row-sub">
              {frDateTime(e.created_at)} · après un Instant « {e.feeling || e.need || "personnalisé"} »
              {e.minutes ? ` de ${e.minutes} min` : ""}
              {e.pillar ? ` · pilier ${e.pillar}` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
